import { InvestmentsServicesProductsPage } from "@nvb/ui";
import { usePageContext } from "vike-react/usePageContext";

/**
 * Both deal grids came from a browser-only fetch, so the prerendered HTML held
 * an empty state. The build-time snapshots travel in `pageContext.initialData`
 * (see `pages/+onBeforeRender.ts`) and seed `InfiniteScroll`, which refetches
 * page 1 on mount and replaces the seed.
 */
export default function Page() {
	const { initialData } = usePageContext();

	const primary = (initialData?.dealsPrimary as { data?: unknown[] } | undefined)?.data;
	const secondary = (initialData?.dealsSecondary as { data?: unknown[] } | undefined)?.data;

	return (
		<InvestmentsServicesProductsPage
			{...(primary?.length ? { initialDealsPrimary: primary } : {})}
			{...(secondary?.length ? { initialDealsSecondary: secondary } : {})}
		/>
	);
}
